import { SET_PARTNER, GET_PARTNER, SET_BILLING_ITEMS, GET_BILLING_ITEMS } from "+state/actions/index";
import PartnerModel from "models/PartnerModel";
import { ManualSponsorshipConfiguration } from "interfaces/PartnersInterface";

interface PartnerState {
	contextPartner: PartnerModel;
	billingItems?: {
		manualSponsorshipConfiguration?: ManualSponsorshipConfiguration;
	};
}

const initState: PartnerState = {
	contextPartner: new PartnerModel({}),
	billingItems: {
		manualSponsorshipConfiguration: undefined
	}
};

const PartnerReducer = (state = initState, action) => {
	if (action.type === SET_PARTNER) {
		return {
			...state,
			contextPartner: action.payload
		};
	} else if (action.type === SET_BILLING_ITEMS) {
		return {
			...state,
			billingItems: {
				...state.billingItems,
				...action.payload
			}
		};
	} else {
		return state;
	}
};

export default PartnerReducer;
